<script>
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";
    import apigeneric from "@/helpers/apigeneric";
    import Loader from "@/components/widgets/loader";
    import Banner from "../components/banner";
    import apibtoast from "@/helpers/apibtoast";

    
    export default {
      page: {
        title: "Web Siteleri",
        meta: [
          {
            name: "description",
            content: appConfig.description,
          },
        ],
      },
      components: {
        Layout,
        Loader,
        Banner,
    
      },
      mixins: [apigeneric, apibtoast],
      data() {
        return {
          TableData: {},
          DefaultPage: 1,
          Page: {
            PageNumber: "1",
            PageSize: "10",
            PageDataSize: "1",
          },

          
          
        };
      },
      methods: {
        Get() {
          this.ActionsFilterGet({ Service: "komisyonlar", 
      Page: this.Page,
       Filter: "&Websiteid="+window.$cookies.get("website")
        }).then(
        (res) => {
          this.TableData = res.Data;
          this.Page.PageDataSize = res.TotalCount;
        }
      );

          }
      },
    };
    </script>
        
    <template>
      <Loader>
        <Layout>
          <Banner />
          <div class="graduates">
        <div class="container">
          <div class="table-graduate">
            <p class="h2 text-center cl-service-dark">{{ $t("komisyonlar.Title") }}</p>
            <div class="container">
              

              <ul class="table-main">
                <li class="head bg-service">
                  <div class="row">
                    <div class="col-md-9">
                      <span class="order">{{
                        $t("komisyonlar.Table.Komisyon")
                      }}</span>
                    </div>
                    <div class="col-md-3" style="text-align:center">
                      <span>{{ $t("komisyonlar.Table.Islem") }}</span>
                    </div>
                  </div>
                </li>
                <li v-for="(Data, index) in TableData" :key="index">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-9 l-flex">
                        <span class="order">{{ Data.Title }}</span>
                      </div>
                      <div class="col-md-3" style="text-align:center"  >
                        <b-button-group>
                          <router-link 
                          class="btn btn-info bx bx-search-alt mx-auto"
                          style="color: #00758f; font-size: 20px;"
                          id="topnav-components"
                          :to="'komisyonpersoneller/' + Data.Id"
                          role="button"
                        >
                          <i></i>
                        </router-link>
                        </b-button-group>
                      </div>
                    </div>
                  </div>
                </li>
              </ul> 
              <b-pagination
                class="pagination pagination-rounded justify-content-end mb-2"
                v-model="DefaultPage"
                :total-rows="Page.PageDataSize"
                :per-page="Page.PageSize"
                aria-controls="my-table"
                @input="ChangePage(DefaultPage)"
              >
              </b-pagination>
            </div>
          </div>
        </div>
      </div>
        </Layout>
      </Loader>
    </template>
        